import { render, staticRenderFns } from "./LayoutSecond.vue?vue&type=template&id=07b8b4a0&scoped=true&"
import script from "./LayoutSecond.vue?vue&type=script&lang=js&"
export * from "./LayoutSecond.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSecond.vue?vue&type=style&index=0&id=07b8b4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8b4a0",
  null
  
)

export default component.exports